module.exports = __webpack_public_path__ + "fonts/noto-sans-jp-v25-latin-900.77c323b.eot";